<template>
  <div>
    <div class="userlogin">
      <div class="shop" v-if="token">
        <!-- <intention></intention> -->
      </div>
      <!-- <div
        class="login-check"
        v-if="!token"
        @click="(dialogFormVisible = true), hangdelLogin('登录')"
      >
        登录
      </div> -->
      <!-- <div class="userinfo" >我的</div> -->
      <!-- <el-tooltip placement="top" v-if="token" effect="light">
        <div slot="content">
          <div>
            <el-button style="margin-top: 10px" @click="dialogUserinfo = true"
              >个人中心</el-button
            >
          </div>
          <div>
            <el-button
              style="margin-top: 10px"
              @click="(dialogChangePassWord = true), hangdelLogin('修改密码')"
              >修改密码</el-button
            >
          </div>
          <div>
            <el-button style="margin-top: 10px" @click="handleExit()"
              >退出登录</el-button
            >
          </div>
        </div>
        、
      </el-tooltip> -->
    </div>
    <!-- 登录表单 -->
    <el-dialog title="用户登录" :visible.sync="dialogFormVisible" @close="refreshCode">
      <div class="select">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="验证码" name="first">
            <div>
              <el-form
                :model="form"
                v-loading="loading"
                status-icon
                :rules="rules1"
                ref="ruleForm1"
                class="demo-ruleForm"
              >
                <el-form-item prop="phone">
                  <el-input
                    v-model="form.phone"
                    maxlength="11"
                    clearable
                    placeholder="请输入手机号码"
                    prefix-icon="el-icon-mobile-phone"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input
                    v-model="form.code"
                    clearable
                    maxlength="6"
                    placeholder="请输入验证码"
                    prefix-icon="el-icon-message"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="handleGetCode(form.phone)"
                    :disabled="disabled"
                    style="margin-left: 20px"
                    >{{
                      disabled == true ? `${timer}秒` : "获取验证码"
                    }}</el-button
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    style="width: 100%; height: 40px"
                    type="primary"
                    @click="handleSubmit('ruleForm1')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="密码登录" name="second">
            <div>
              <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width=""
                v-loading="loading"
                class="demo-ruleForm"
              >
                <el-form-item label="" prop="username">
                  <el-input
                    type="text"
                    v-model="ruleForm.username"
                    placeholder="请输入账号"
                    prefix-icon="el-icon-user-solid"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input
                    type="password"
                    v-model="ruleForm.password"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="code">
                  <div style="width: 200px; display: flex; align-items: center">
                    <el-input
                      v-model.number="ruleForm.code"
                      placeholder="请输入验证码"
                      prefix-icon="el-icon-edit-outline"
                    ></el-input>
                  </div>
                  <div
                    style="
                      width: 120px;
                      height: 30px;
                      position: relative;
                      top: -5px;
                      cursor: pointer;
                    "
                    @click="refreshCode"
                  >
                    <img :src="codeUrl" />
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button
                    style="width: 100%; height: 40px"
                    type="primary"
                    @click="submitForm('ruleForm')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="registerbutton">
        <span style="color: #a8a8a8"
          >还没有账号？
          <span style="color: #2c83f6; cursor: pointer" @click="register()"
            >立即注册</span
          ></span
        >
      </div>
    </el-dialog>
    <!-- 展示个人信息 -->
    <el-dialog title="个人信息" :visible.sync="dialogUserinfo">
      <div v-if="token">
        <h3>
          企业名称:
          <span
            style="font-weight: 100; font-size: 16px; padding-left: 10px"
            v-if="userinfo.companyName"
            >{{ userinfo.companyName }}</span
          >
          <span v-else style="font-weight: 100; padding-left: 10px"
            >暂无信息，请更新</span
          >
        </h3>
        <h3>
          社会信用代码:
          <span
            style="font-weight: 100; font-size: 16px; padding-left: 10px"
            v-if="userinfo.identityCode"
          >
            {{ userinfo.identityCode }}</span
          >
          <span v-else style="font-weight: 100; padding-left: 10px"
            >暂无信息，请更新</span
          >
        </h3>
        <h3>
          企业简介:
          <span
            style="font-weight: 100; font-size: 16px; padding-left: 10px"
            v-if="userinfo.companySynopsis"
            >{{ userinfo.companySynopsis }}</span
          >
          <span v-else style="font-weight: 100; padding-left: 10px"
            >暂无信息，请更新</span
          >
        </h3>
        <el-button
          type="primary"
          @click="(dialogUserinfo = false), (dialogAmend = true)"
          style="width: 100%; height: 40px"
          >更新信息</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改个人信息弹框 -->
    <el-dialog title="修改信息" :visible.sync="dialogAmend">
      <div v-if="token">
        <el-form
          :model="userinfo"
          v-loading="loading"
          status-icon
          class="demo-ruleForm"
          :label-position="labelPosition"
          ref="dynamicValidateForm"
        >
          <el-form-item label="企业名称">
            <el-input v-model="userinfo.companyName" clearable></el-input>
          </el-form-item>
          <el-form-item label="社会信用代码">
            <el-input v-model="userinfo.identityCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="企业简介">
            <el-input
              v-model="userinfo.companySynopsis"
              type="textarea"
              :rows="4"
              :autosize="{ minRows: 5, maxRows: 20 }"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width: 100%; height: 40px"
              type="primary"
              @click="handleChangeUserinfo('dynamicValidateForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 注册弹框 -->
    <el-dialog title="注册" :visible.sync="dialogregister">
      <el-form
        :model="registerForm"
        v-loading="loading"
        status-icon
        :rules="rules2"
        ref="ruleForm2"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="phone">
          <el-input
            v-model="registerForm.phone"
            maxlength="11"
            clearable
            placeholder="请输入账号"
            prefix-icon="el-icon-user-solid"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input
            v-model="registerForm.password"
            maxlength="16"
            clearable
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="registerForm.code"
            clearable
            maxlength="6"
            placeholder="请输入验证码"
            prefix-icon="el-icon-message"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
          <el-button
            type="primary"
            @click="handleGetCode(registerForm.phone)"
            :disabled="disabled"
            style="margin-left: 20px"
            >{{ disabled == true ? `${timer}秒` : "获取验证码" }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleRegister('ruleForm2')"
            style="width: 100%"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
      <div class="registerbutton">
        <span style="color: #a8a8a8"
          >已有账号？
          <span
            style="color: #2c83f6; cursor: pointer"
            @click="(dialogregister = false), (dialogFormVisible = true)"
            >立即登录</span
          ></span
        >
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogChangePassWord">
      <el-form
        :model="changepasswordForm"
        v-loading="loading"
        status-icon
        :rules="rules3"
        ref="ruleForm3"
        class="demo-ruleForm"
        :label-position="labelPosition"
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="changepasswordForm.password"
            maxlength="16"
            clearable
            placeholder="请输入新密码"
            type="password"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPassword">
          <el-input
            v-model="changepasswordForm.newPassword"
            maxlength="16"
            clearable
            type="password"
            placeholder="请再次输入新密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model="changepasswordForm.phone"
            maxlength="11"
            clearable
            placeholder="请输入手机号码"
            prefix-icon="el-icon-mobile-phone"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="changepasswordForm.code"
            clearable
            maxlength="6"
            placeholder="请输入验证码"
            prefix-icon="el-icon-message"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
          <el-button
            type="primary"
            @click="handleGetCode(changepasswordForm.phone)"
            :disabled="disabled"
            style="margin-left: 20px"
            >{{ disabled == true ? `${timer}秒` : "获取验证码" }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="hanldeChagnePassWord('ruleForm3')"
            style="width: 100%; height: 40px"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPhoneCode,
  PhoneLogin,
  getUserInfo,
  loginCheck,
  UserRegister,
  UserChange,
  PassWordChange,
  Logout,
} from "@/api/login/index";
import { randomLenNum, encryption } from "@/utils/compressImage.js";
import intention from "@/components/currency/intention";
import { infoFavoriteList } from "@/api/setting/investment.js";
export default {
  name: "",
  components: { intention },
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.changepasswordForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "top",
      userinfo: {
        companyName: "",
        identityCode: "",
        companySynopsis: "",
        nickName: "",
        userName: "",
      },
      loading: false,
      dialogregister: false,
      dialogFormVisible: false,
      dialogUserinfo: false,
      dialogChangePassWord: false,
      dialogAmend: false,
      form: {
        phone: null,

        code: null,
      },
      disabled: false,
      timer: 60,
      number: null,

      buttonType: [{ name: "验证码登录" }, { name: "账号密码" }],
      buttonTypeindex: 0,
      ruleForm: {
        username: "",
        password: "",
        code: "",
        randomStr: "",
      },
      registerForm: {
        phone: null,
        password: "",
        code: "",
      },
      changepasswordForm: {
        password: "",
        newPassword: "",
        code: "",
        phone: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      rules1: {
        phone: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3546789]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      rules2: {
        phone: [{ required: true, message: "请输手机号码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      rules3: {
        phone: [{ required: true, message: "请输手机号码", trigger: "blur" }],
        password: [{ required: true, message: "请输密码", trigger: "blur" }],
        newPassword: [
          { required: true, validator: validatePass1, trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      // rules4:{
      //   code:[
      //     { required: true, message: "请输入社会信用代码", trigger: "change" },
      //     {
      //       pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
      //       message: "请输入合法社会信用代码",
      //       trigger: "blur",
      //     },
      //   ]
      // },
      codeUrl: "",
      token: "",
      activeName: "first",
    };
  },
  watch: {
    dialogFormVisible(newValue, oldValue) {
      if (!newValue) {
        clearInterval(this.timer1);
        this.disabled = false;
        this.timer = 60;
        this.form.phone = null;
        this.form.code = "";
        this.loading = false;
      }
    },
  },
  created() {
    this.$eventBus.on("logout", () => {
       this.token=false
    });
  },
  mounted() {
    this.$eventBus.$on("isToken", (msg) => {
      if (!msg) {
        this.dialogFormVisible = true;
      }
    });
    this.refreshCode();
    this.token = sessionStorage.getItem("access_token")
      ? sessionStorage.getItem("access_token")
      : "";
    this.userinfo = sessionStorage.getItem("userInfo")
      ? JSON.parse(sessionStorage.getItem("userInfo"))
      : "";
  },
  methods: {
    // 登录重置输入框信息
    hangdelLogin(item) {
      this.loading = false;
      if (item == "登录") {
        (this.ruleForm.username = ""),
          (this.ruleForm.password = ""),
          (this.ruleForm.code = "");
        this.randomStr = "";
      } else if ("修改密码") {
        this.changepasswordForm = {
          password: "",
          newPassword: "",
          code: "",
          phone: "",
        };
      }
    },
    // 验证码登录
    handleSubmit(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.loading = true;
          PhoneLogin(this.form).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.msg);
              // this.$router.go(0)
              // this.$router.push({path:"/"})
              this.dialogFormVisible = false;
              this.loading = false;
              this.setSingleGlobalVariable(
                "access_token",
                res.data.data.access_token
              );
              this.setSingleGlobalVariable(
                "refresh_token",
                res.data.data.refresh_token
              );
              this.setSingleGlobalVariable(
                "expires_in",
                res.data.data.expires_in
              );
              this.token = sessionStorage.getItem("access_token")
                ? sessionStorage.getItem("access_token")
                : "";

              getUserInfo().then((res) => {
                if (res.data.success) {
                  this.userinfo = res.data.data;
                  this.setSingleGlobalVariable(
                    "userInfo",
                    JSON.stringify(res.data.data)
                  );
                  this.$eventBus.emit("isDetailRefresh", true);
                  this.$eventBus.emit("isLogin");
                }
              });
              this.getTotal();
            } else {
              this.loading = false;
              this.$message.error(res.data.msg);
              clearInterval(this.timer1);
              this.timer = 60;
            }
          });
        } else {
          return false;
        }
      });
    },
    // // 获取验证码
    handleGetCode(phone) {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!reg.test(phone)) {
        this.$message.warning("请输入正确的手机号码");
      } else {
        this.loading = true;
        this.disabled = true;
        GetPhoneCode(phone).then((res) => {
          this.$message.success(res.data.msg);
          this.loading = false;
        });
        this.timer1 = setInterval(() => {
          this.timer--;
          if (this.timer == 0) {
            clearInterval(this.timer1);
            this.disabled = false;
            this.timer = 60;
          }
        }, 1000);
      }
    },

    // 登录方式切换
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    // //账号密码登录的提交
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const user = encryption({
            data: this.ruleForm,
            key: "ituzhi.com,micro",
            param: ["password"],
          });
          let { data: res } = await loginCheck(
            user.username,
            user.password,
            user.code,
            user.randomStr
          );
          if (res.success) {
            this.loading = false;
            // this.$router.go(0)
            this.setSingleGlobalVariable("access_token", res.data.access_token);
            this.setSingleGlobalVariable(
              "refresh_token",
              res.data.refresh_token
            );
            this.setSingleGlobalVariable("expires_in", res.data.expires_in);
            this.token = sessionStorage.getItem("access_token")
              ? sessionStorage.getItem("access_token")
              : "";
            this.$message.success(res.data.msg);

            this.dialogFormVisible = false;
            getUserInfo().then((res) => {
              if (res.data.success) {
                if (res.data.success) {
                  this.userinfo = res.data.data;
                  // this.setSingleGlobalVariable("userInfo", res.data.data);
                  this.setSingleGlobalVariable(
                    "userInfo",
                    JSON.stringify(res.data.data)
                  );
                  this.$eventBus.emit("isLogin");
                  this.$eventBus.emit("isDetailRefresh", true);
                }
              }
            });
            this.getTotal();
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.refreshCode();
          }
        }
      });
    },
    //获取意向总数
    getTotal() {
      infoFavoriteList({ current: 1, size: 100 }).then((res) => {
        if (res.data.success) {
          this.$eventBus.emit("total", res.data.data.total);
        }
      });
    },
    // // 获取图片
    refreshCode() {
      this.ruleForm.code = "";
      this.codeUrl = systemConfig.serverUrl + "/code"; //验证码接口
      this.ruleForm.randomStr = randomLenNum(4, true);
      this.codeUrl = `${this.codeUrl}?randomStr=${this.ruleForm.randomStr}`;
    },
    register() {
      this.dialogregister = true;
      this.dialogFormVisible = false;
    },
    // // 用户注册
    async handleRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          // const user = encryption({
          //   data: this.registerForm,
          //   key: "ituzhi.com,micro",
          //   param: ["password"],
          // });
          await UserRegister(this.registerForm).then((res) => {
            this.loading = false;
            this.dialogFormVisible = false;
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.dialogFormVisible = true;
              this.dialogregister = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // // 修改信息
    async handleChangeUserinfo(dynamicValidateForm) {
      this.loading = true;
      // this.$refs[dynamicValidateForm].validate((valid)=>{
      //   if(!valid){
      //     alert('submit!');
      //      return
      //   }else{
      //     console.log('error submit!!');
      //       return false;
      //   }
      // })
      const user = encryption({
        data: this.userinfo,
        key: "ituzhi.com,micro",
        param: ["password"],
      });
      await UserChange(this.userinfo).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.dialogAmend = false;
          getUserInfo().then((res) => {
            if (res.data.success) {
              if (res.data.success) {
                this.userinfo = res.data.data;
                // this.setSingleGlobalVariable("userInfo", res.data.data);
                this.setSingleGlobalVariable(
                  "userInfo",
                  JSON.stringify(res.data.data)
                );
              }
            }
          });
        } else {
          this.$message.error(res.data.msg);
          this.dialogAmend = false;
        }
      });
    },
    // 修改密码
    async hanldeChagnePassWord(formName) {
      // this.loading=true
      // this.$refs[formName].validate(async (valid){}
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          PassWordChange(this.changepasswordForm).then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.handleExit();
              this.dialogChangePassWord = false;
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 退出登录
    handleExit() {
      this.loading = true;
      Logout().then((res) => {});
      sessionStorage.clear();
      this.userinfo.companyName = "";
      (this.userinfo.identityCode = ""),
        (this.userinfo.companySynopsis = ""),
        (this.userinfo.nickName = ""),
        (this.token = "");
      this.loading = false;
      this.dialogUserinfo = false;
      this.$eventBus.emit("isDetailRefresh", false);
      this.$store.dispatch("clearAllVuex");
      this.$message.success("退出成功");
    },
  },
};
</script>

<style scoped>
.userlogin {
  width: 340px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.shop {
  margin-right: 20px;
}

.shop-span1 {
  padding: 0 2px;
  font-size: 12px;
}

.shop-span2 {
  font-size: 12px;
  color: red;
}

.login-check,
.userinfo {
  color: #1f42a1de;
  cursor: pointer;
}

>>> .el-dialog {
  width: 440px;
  border-radius: 8px;
  position: relative;
}

>>> .el-form-item__content {
  display: flex;
  margin-left: 0px;
}

>>> .el-form-item el-form-item--mini {
}

.dialog-footer {
  /* margin-right: 30px; */
}

.select {
  width: 100%;
}

>>> .el-dialog__body {
  padding: 10px 50px;
}

.activate {
  background: #409eff;
  color: #fff !important;
}

>>> .el-tabs__nav-wrap::after {
  background: transparent;
}

>>> .el-tabs__item.is-active {
  font-size: 18px;
  font-weight: bold;
  color: #212121;
}

>>> .el-tabs__item {
  /* color: red; */
  font-size: 18px;
}

>>> .el-dialog__title {
  display: inline-block;
  font-weight: 700;
}

.registerbutton {
  /* margin-top: 30px; */
  width: 200px;
  height: 30px;
  /* background: red; */
  font-size: 14px;
  margin-bottom: 30px;
}

>>> .el-input {
  height: 40px;
}

>>> .el-input--mini .el-input__inner {
  height: 40px;
  min-height: 40px;
}
</style>